import React, { useEffect, useState } from "react";
import AddModal from "./addModal";
import EditModal from "./editModal";
import RemoveModal from "./removeModal";
import AppointModal from "../sharetable/appointModal";

import { useDispatch, useSelector } from "react-redux";
import { getOfficerList } from "../../actions/officer";
import {
  backendUrl,
  HOLDERS,
  HOLDERS_PAGE_TYPE,
  I_POP_OVER,
  POSITIONS,
} from "../../constants";
import InfoModalStatic from "../../pages/dashboard/infoModalStatic";
import StartMessageModel from "../message/StartMessageModel";
import { getPendingInvites } from "../../actions/promoters";
import { useLocation, useNavigate } from "react-router";
import { useRef } from "react";
import AddEmail from "../sharetable/addEmail";
import { getShareHolderList, resendEmailAction } from "../../actions/shareHolder";
import ContentLoader from "react-content-loader";
import TimeFormat from "../timeFormat/timeFormat";

export const INVITE_TYPE = {
  OFFICERS: 0,
  INVITES: 3,
};

export default function OfficerTable(props) {
  const type = props.type;

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const directorRef = useRef();
  const { selectedCompany, hasPermission, loadCompany } = useSelector(
    (state) => state.company
  );
  const { objective } = selectedCompany
  const preDefaultDirectors = (objective?.length > 0 && objective[0]?.defaultDirectors) ? objective[0]?.defaultDirectors?.map(item => item.email) : []

  const { user } = useSelector(state => state.auth);
  const { shareHolder } = useSelector((state) => state.shareHolder);
  const { officers, pendingOfficerList, loadOfficer } = useSelector((state) => state.officers);
  const { holdNextInviteTempData } = useSelector((state) => state.promoters);
  const [addModalShow, setAddModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [removeModalShow, setRemoveModalShow] = useState(false);
  const [appointModalShow, setAppointModalShow] = useState(false);

  const [performObj, setPerformObj] = useState({});
  const [infoModalStaicShow, setInfoModalStaticShow] = useState(false);
  const [infoModalStaicShowType, setInfoModalStaticShowType] = useState(null);
  const [messageModal, setMessageModal] = useState(false);
  const [deleteOfficerType, setDeleteOfficerType] = useState(null);
  const [currentSelection, setCurrentSelection] = useState(null);
  const [loader, setLoader] = useState(null)

  const [record, setRecord] = useState(5);
  const [directorType, setDirectorType] = useState(null);
  const [addEmail, setAddEmail] = useState(false);


  useEffect(() => {
    if (props?.triggerHandleMessageInternal && holdNextInviteTempData?.type === HOLDERS.directors) {
      const getList = officers.find(x => x.email === holdNextInviteTempData?.email)
      if (getList) {
        props?.closeCongratulationsPopup()
        handleMessage(getList);
      } else {
        props?.closeCongratulationsPopup()
      }
    }
  }, [props?.triggerHandleMessageInternal])

  const addModalClose = () => {
    setAddModalShow(false);
  };

  const handleShow = () => {
    setAddModalShow(true);
    location.state = ""
  }

  const editModalClose = () => {
    setEditModalShow(false);
    setPerformObj({});
  };
  const handleEditModalShow = (valueObj) => {
    setPerformObj(valueObj);
    setEditModalShow(true);
  };

  const removeModalClose = () => {
    setRemoveModalShow(false);
  };
  const handleRemoveModalShow = (type, valueObj) => {
    setDeleteOfficerType(type);
    setPerformObj(valueObj);
    setRemoveModalShow(true);
  };

  const appointModalClose = () => {
    setAppointModalShow(false);
    navigate({ state: "" });
  };

  const handleAppointModalShow = (valueObj) => {
    setPerformObj(valueObj);
    setAppointModalShow(true);
  };

  const handleMessage = (list) => {
    setCurrentSelection(list)
    setMessageModal(true);
  };

  useEffect(() => {
    const { id } = selectedCompany;
    if (id) {
      // if (type === HOLDERS_PAGE_TYPE.INVITES) {
      //   dispatch(getPendingInvites(id, 3));
      // } else {
      dispatch(getShareHolderList(id));
      dispatch(getOfficerList(id));
      // }
    }
  }, [dispatch, selectedCompany]);

  const onLoad = () => {
    setRecord(record + 5);
  };

  const getPositionName = (position, isAppointed) => {
    var returnVal = "";
    var filter = POSITIONS.filter((x) => x.value === position);
    if (filter.length > 0) {
      returnVal = filter[0].name;
    }
    return (isAppointed ? "Approved <br/>" : "Potential <br/>") + (returnVal ? returnVal.toLowerCase() : returnVal);
  };

  const handleClickInfo = (type) => {
    setInfoModalStaticShow(true);
    setInfoModalStaticShowType(type);
  };

  useEffect(() => {
    if (location.state === "inviteDirector") {
      setAddModalShow(true);
      navigate({ state: "" })
    } else if (location.state === "appointDirector") {
      navigate({ state: "" })
      directorRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const handleEmailShow = (value, type) => {
    setAddEmail(value);
    setDirectorType(type);
  };

  const checkAppointPermission = (list) => {
    var returnValue = false
    // const shareholderList = shareHolder.filter(x=> x.email === user.email && x.isAppointed === true)
    // if(!list.isAppoint && !list.isAppointed && shareholderList.length > 0){
    //   returnValue =  true
    // }
    if (!list.isAppoint && !list.isAppointed && !returnValue && selectedCompany.id === list.company._id && user.id === list.company.user && list.isDeleteApproved) {
      returnValue = true
    }
    return returnValue
  }

  const checkDeletePermission = (list) => {
    var returnValue = false
    if (list.isDeleteApproved && list.email === user.email) {
      returnValue = true
    }
    return returnValue
  }

  const resendEmail = async (inviteId) => {
    setLoader(inviteId)
    await dispatch(resendEmailAction(inviteId));
    setLoader(null)
  }

  return (
    <>
      <div className="card">
        <div className="card-header pb-0">
          <div className="row">
            <div className="col-lg-7 col-6 col-md-7 col-sm-6">
              <h6 className="cashHeaderText cashDarkText m-0 high-cap px-2">
                {type === HOLDERS_PAGE_TYPE.INVITES ? "Director  invites" : 'Directors'}{" "}
                <img
                  src="assets/img/info-icon.svg"
                  onClick={() => handleClickInfo(I_POP_OVER.DIRECTORS)}
                  alt=""
                  className="m-0 pb-1 cursorPointer"
                />
              </h6>
            </div>

            <div className="col-lg-5 col-6 col-md-5 col-sm-6 text-end">
              <div className="dropdown float-lg-end">
                {!loadOfficer && !loadCompany && selectedCompany &&
                  selectedCompany.id &&
                  hasPermission && (user?.id === selectedCompany?.user) &&
                  // type !== HOLDERS_PAGE_TYPE.INVITES && (
                  <button
                    className="btn add-button add-button-shareholder m-0 companySpotlightStep2"
                    onClick={handleShow}
                  >
                    Add directors
                  </button>
                  // )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 pb-2 pt-2">
          {officers && officers.length > 0 ? (
            <div className="table-responsive">
              <table
                ref={directorRef}
                className="table align-items-center mb-0 table-sharholder"
              >
                <thead>
                  <tr className="">
                    <th className="accountPrimaryText">Name</th>
                    {type !== HOLDERS_PAGE_TYPE.INVITES && (
                      <th className="accountPrimaryText">Position</th>
                    )}
                    {type === HOLDERS_PAGE_TYPE.INVITES && (
                      <th className="accountPrimaryText">Email address</th>
                    )}
                    <th className="accountPrimaryText">Date added</th>
                    <th className="accountPrimaryText text-center">Actions</th>
                    <th className="accountPrimaryText">Status <img
                      src="assets/img/info-icon.svg"
                      onClick={() => handleClickInfo(type === HOLDERS_PAGE_TYPE.INVITES ? I_POP_OVER.SHAREHOLDERS_DIRECTOR_INVITEE_STATUS : I_POP_OVER.SHAREHOLDERS_DIRECTOR_STATUS)}
                      alt=""
                      className="m-0 pb-1 cursorPointer"
                    /></th>
                  </tr>
                </thead>
                <tbody className="text-row-color">
                  {officers &&
                    officers.slice(0, record).map((list, index) => (
                      <tr
                        className={
                          (!list.isApproved ? "active" : "",
                            list.isAppoint
                              ? "appoint"
                              : list.isAppointed
                                ? "appointed"
                                : "")
                        }
                        key={index}
                      >
                        <td>
                          {!loadOfficer && !loadCompany ? (
                            <div className="d-flex">
                              <div className="d-flex flex-column justify-content-center">
                                <h6 className="mb-0 shareHolderName accountSecondaryText activity_wrapper">
                                  {/* <div
                                    className="shareholder-img"
                                    style={{
                                      backgroundImage: `url(${list &&
                                        list.profilePic &&
                                        list.profilePic.filename
                                        ? backendUrl + list.profilePic.filename
                                        : "assets/img/Frame1.svg"
                                        })`,
                                    }}
                                  /> */}
                                  {list.name}
                                  {((list.isVerified && !list.isAppoint) ||
                                    (list.isAppointed && !list.isAppoint)) && (
                                      <img
                                        className="verifiedIcon"
                                        src="assets/img/verified.svg"
                                        alt="verified.svg"
                                      />
                                    )}

                                  {list.isAppoint && (
                                    <img
                                      className="verifiedIcon"
                                      src="assets/img/ApprovedBadge.svg"
                                      alt="ApprovedBadge.svg"
                                    />
                                  )}
                                </h6>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <ContentLoader width="100%" height={15}>
                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                              </ContentLoader>
                            </div>
                          )}
                        </td>
                        <td className="align-middle">
                          {!loadOfficer && !loadCompany ? (

                            <span className="accountSecondaryText">
                              {list.position &&
                                type !== HOLDERS_PAGE_TYPE.INVITES && (
                                  <span dangerouslySetInnerHTML={{
                                    __html: getPositionName(list.position, list.isAppointed),
                                  }}></span>
                                )}
                              {type === HOLDERS_PAGE_TYPE.INVITES && (
                                <div
                                  className="email-share limit-text cursor-pointer activity_wrapper"
                                  title={list.email}
                                >
                                  {list.email}
                                </div>
                              )}
                            </span>
                          ) : (
                            <div>
                              <ContentLoader width="100%" height={15}>
                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                              </ContentLoader>
                            </div>
                          )}
                        </td>
                        <td className="align-middle ">
                          {!loadOfficer && !loadCompany ? (
                            <span className="accountSecondaryText">
                              <TimeFormat time={list.createdAt} type={1} />
                              {/* {moment(list.createdAt).format("DD/MM/YYYY")} */}
                            </span>
                          ) : (
                            <div>
                              <ContentLoader width="100%" height={15}>
                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                              </ContentLoader>
                            </div>
                          )}
                        </td>

                        {/* ----------- */}
                        {/* <td className="action-icons d-flex align-item-center justify-content-center flex-direction-colum"> */}
                        <td className="text-center">
                          {!loadOfficer && !loadCompany ? (
                            hasPermission && (
                              <>
                                {!pendingOfficerList.some(x => x.email === list.email) ? (
                                  !list.isAppointedSendInvite ? (
                                    <>
                                      {!list.email && (
                                        <>
                                          <span
                                            className="btn btn-link px-0 mb-0 mx-1 right-delete-icon"
                                            data-tooltip-top="Send email to invite"
                                            onClick={() =>
                                              handleEmailShow(list, "director")
                                            }
                                          >
                                            <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                          </span>
                                        </>
                                      )}
                                      {list.isDeleteApproved && list.email && (
                                        <span
                                          className="btn btn-link px-0 mb-0 mx-1"
                                          onClick={() => handleEditModalShow(list)}
                                        >
                                          <i
                                            className="fas fa-pencil-alt"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      )}
                                      {list.isDeleteApproved && list.email && (
                                        user.email !== list.email && (
                                          <span
                                            className="btn btn-link px-0 mb-0 mx-1"
                                            onClick={() => handleMessage(list)}
                                          >
                                            <i
                                              className="fa-solid fa-comment-dots mx-2"
                                            ></i>
                                          </span>)
                                      )}
                                      {checkAppointPermission(list) && (
                                        <span
                                          className="btn btn-link px-0 mb-0 mx-1"
                                          onClick={() =>
                                            handleAppointModalShow(list)
                                          }
                                        >
                                          <i className="fas fa-user-check"></i>
                                        </span>
                                      )}

                                      {checkDeletePermission(list) && (
                                        <span
                                          className="btn btn-link px-0 mb-0 mx-1 right-delete-icon"
                                          onClick={() =>
                                            handleRemoveModalShow(
                                              INVITE_TYPE.OFFICERS,
                                              list
                                            )
                                          }
                                        >
                                          <i
                                            className="fas fa-trash-alt"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      )}
                                      &nbsp;
                                    </>
                                  ) : (
                                    <span className="btn btn-link px-0 mb-0 mx-1 right-delete-icon">&nbsp;</span>
                                  )
                                ) : pendingOfficerList.some(x => x.email === list.email && x.is_delete_requested === true && x.company === selectedCompany?.id) ? (
                                  <>&nbsp;</>
                                ) : (
                                  (!preDefaultDirectors.includes(list.email) ? (
                                    <>
                                      <span
                                        className="btn btn-link px-0 mb-0 mx-1 right-delete-icon"
                                        onClick={() =>
                                          handleRemoveModalShow(
                                            INVITE_TYPE.INVITES,
                                            list
                                          )
                                        }
                                      >
                                        <i
                                          className="fas fa-trash-alt"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                      {user.id === selectedCompany.user &&
                                        <button disabled={loader} onClick={() => resendEmail(pendingOfficerList.filter(x => x.email === list.email)[0].id)} className="btn pending-button-second m-0 ms-3">
                                          {loader === pendingOfficerList.filter(x => x.email === list.email)[0].id && (<i className="animateSpin fa-solid fa-circle-notch"></i>)} Resend email
                                        </button>
                                      }
                                    </>
                                  ) : (<span className="btn btn-link px-0 mb-0 mx-1 right-delete-icon">&nbsp;</span>))
                                )}
                              </>
                            )) : (
                            <div>
                              <ContentLoader width="100%" height={15}>
                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                              </ContentLoader>
                            </div>
                          )}
                        </td>

                        {/* Status */}
                        <td className="status-type">
                          {!loadOfficer && !loadCompany ? (
                            !pendingOfficerList.some(x => x.email === list.email) ? (
                              <>
                                {list.isAppointedSendInvite ? (
                                  <button className="btn pending-button-second m-0 ">
                                    Pending
                                  </button>
                                ) : (
                                  <>{list.email ? (
                                    !list.isApproved || (list.isAppoint && list.isDeleteApproved) ? (
                                      <button className="btn amendment-progress-button-second">
                                        Acceptance in progress
                                      </button>
                                    ) : (!list.isEditApproved && !list.isAppoint) ? (
                                      <button className="btn amendment-progress-button">
                                        Amendment in progress
                                      </button>
                                    ) : (!list.isDeleteApproved) ? (
                                      <button className="btn amendment-progress-button deletion">
                                        deletion in progress
                                      </button>
                                    ) : (
                                      <button className="btn active-button-second pending-button-second m-0">
                                        {list?.verification === 'myinfo' ? "Official" : "Invite accepted"}
                                      </button>
                                    )
                                  ) : (
                                    list?.verification === 'myinfo' && (
                                      <button className="btn active-button-second pending-button-second m-0">
                                        Official
                                      </button>
                                    )
                                  )}
                                  </>
                                )}
                              </>

                            ) : pendingOfficerList.some(x => x.email === list.email && x.is_delete_requested === true && x.company === selectedCompany?.id) ? (
                              <button className="btn amendment-progress-button deletion">
                                Removal in progress
                              </button>
                            ) : (
                              <button className="btn pending-button-second m-0 ">
                                Pending
                              </button>
                            )) : (
                            <div>
                              <ContentLoader width="100%" height={15}>
                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                              </ContentLoader>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {!loadOfficer && !loadCompany && officers.length > record && (
                <button
                  onClick={onLoad}
                  className="btn btn-sm  view-button mb-4 mt-3"
                >
                  View all
                </button>
              )}
            </div>
          ) : (
            <div className="no-record d-flex pt-2 pb-2">
              <div className="d-flex flex-column justify-content-center">
                {!loadOfficer && !loadCompany ? (
                  <h6 className="mb-0 text-sm table-heading ">
                    No {type === HOLDERS_PAGE_TYPE.INVITES ? "Director" : 'Appointments'}{" "}added
                  </h6>
                ) : (
                  <div>
                    <ContentLoader width="100%" height={15}>
                      <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                    </ContentLoader>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <AddModal addModalShow={addModalShow} addModalClose={addModalClose} pageType={type} />
      <AddEmail
        emailShow={addEmail}
        emailClose={() => setAddEmail(false)}
        holdertype={directorType}
      />
      <EditModal
        editModalShow={editModalShow}
        editModalClose={editModalClose}
        performObj={performObj}
        pageType={type}
      />
      <RemoveModal
        pendingOfficerList={pendingOfficerList}
        removeModalShow={removeModalShow}
        removeModalClose={removeModalClose}
        performObj={performObj}
        type={deleteOfficerType}
      />

      <AppointModal
        appointModalShow={appointModalShow}
        appointModalClose={appointModalClose}
        type={HOLDERS.directors}
        performObj={performObj}
      />

      <InfoModalStatic
        infoModalStaticShow={infoModalStaicShow}
        infoModalStaticClose={() => setInfoModalStaticShow(false)}
        infoModalStaicShowType={infoModalStaicShowType}
      />

      <StartMessageModel
        messageModal={messageModal}
        addModalClose={() => setMessageModal(false)}
        listing={officers}
        currentSelection={currentSelection}
        type={HOLDERS.directors}
      />
    </>
  );
}
